// tslint:disable:max-line-length
import * as React from 'react';

import { createIcon } from '../icon';

export const CianGroupPure = createIcon(`
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="148" height="31" viewBox="0 0 148 31">
    <defs>
      <path id="a" d="M2.754 4.513c0-1.1.896-1.991 2.001-1.991 1.107 0 2.005.891 2.005 1.991a2 2 0 0 1-2.005 1.993 1.998 1.998 0 0 1-2-1.993M.291 4.475c0 .73.179 1.42.493 2.026H.783l.025.044c.016.033.035.069.055.101l3.892 6.808L8.65 6.65l.057-.106.024-.042h-.005a4.365 4.365 0 0 0 .495-2.026c0-2.452-1.999-4.44-4.466-4.44C2.291.036.292 2.024.292 4.476"/>
      <path id="c" d="M.27 9.783l3.55 3.529 6.26-6.226 6.26 6.226 3.55-3.529-2.855-2.838V.377h-3.371v3.215L10.08.028z"/>
    </defs>
    <g fill="none" fill-rule="evenodd" opacity=".6">
      <path fill="#040504" d="M63.974 14.157l-7.287 13.3h3.743l.877-1.863h5.517l.88 1.863h3.728c-2.268-4.385-4.734-9.025-7.3-13.3h-.158zm-1.458 8.87l1.544-3.27 1.548 3.27h-3.092zM82.33 14.51v5.192H77.1v-5.191h-3.46v12.946h3.46v-5.191h5.23v5.19h3.46V14.512zm-36.51 7.002v-6.966h-3.106v13.2h.24l8.792-6.938v6.684h3.118v-13.27h-.24zm-7.728-7.002h-3.46v10.383h-5.229V14.511h-3.46v12.946H36.82v3.27h3.46v-5.834h-2.188zM13.347 4.513c0-1.1.896-1.991 2.001-1.991 1.108 0 2.005.891 2.005 1.991a2 2 0 0 1-2.005 1.993 1.998 1.998 0 0 1-2-1.993m-2.463-.038c0 .73.179 1.42.493 2.026h-.002l.025.044c.016.033.035.069.055.101l3.892 6.808 3.895-6.805.057-.106.024-.042h-.005a4.365 4.365 0 0 0 .495-2.026c0-2.452-1.999-4.44-4.466-4.44-2.464 0-4.463 1.988-4.463 4.44"/>
      <g transform="translate(10.593)">
        <mask id="b" fill="#fff">
          <use xlink:href="#a"/>
        </mask>
        <path fill="#040504" d="M.292.036h8.93v13.418H.292z" mask="url(#b)"/>
      </g>
      <path fill="#040504" d="M.27 23.929l3.55 3.529 6.26-6.227 6.26 6.227 3.55-3.529-2.855-2.839v-6.568h-3.371v3.216l-3.584-3.564z"/>
      <g transform="translate(0 14.146)">
        <mask id="d" fill="#fff">
          <use xlink:href="#c"/>
        </mask>
        <path fill="#040504" d="M.271.028H19.89v13.285H.271z" mask="url(#d)"/>
      </g>
      <path fill="#040504" d="M91.843 27.348H93.1V15.585h6.428v-1.074h-7.685zm17.155-11.763c-1.12-.716-2.875-1.074-5.265-1.074h-2.266v12.837h1.256v-4.425h1.195c2.28 0 3.977-.36 5.089-1.083 1.113-.723 1.67-1.77 1.67-3.142 0-1.359-.56-2.397-1.68-3.113m-.876 5.48c-.865.522-2.238.784-4.12.784h-1.278v-6.264h1.278c1.868 0 3.238.264 4.11.792.873.528 1.308 1.309 1.308 2.34 0 1.044-.432 1.827-1.298 2.349m9.097.252l-4.5-6.808h-1.36l5.193 7.811-3.345 5.033h1.36l8.495-12.844h-1.32zm7.531-6.808v12.838h1.215V15.585h7.911v11.872h1.216V14.511h-.011zm23.054 0h-10.331v12.838h1.215V15.585h7.911v11.872h1.216V14.511z"/>
    </g>
  </svg>
`);

export const CianGroupIcon: React.SFC<{ iconClassName?: string }> = (props: { iconClassName?: string }) => (
  <CianGroupPure className={props.iconClassName} />
);

CianGroupIcon.displayName = 'CianGroupIcon';
